export const GUEST_REQUEST_STATUSES = [
    "pending",
    "accepted",
    "completed",
    "declined",
    "cancelled",
    "refunded",
];
export const GUEST_REQUEST_TRANSITIONS = [
    "accept",
    "complete",
    "decline",
    "cancel",
    "refund",
];
export const SEAT_HOLDING_STATUSES = [
    "pending",
    "accepted",
    "completed",
];
export const REVENUE_STATUSES = ["accepted", "completed"];
export const FINAL_STATUSES = ["declined", "cancelled", "refunded"];
export const GUEST_REQUEST_PAYMENT_STATUSES = [
    "unpaid",
    "authorized",
    "paid",
    "refunded",
    "failed",
];
